import React from "react";
/**
 * How strong a password is, as a bar under the field: red and short while it is weak, orange for medium,
 * green and full for strong. It is as wide as the password is long, up to twelve characters, which is
 * what the text next to it asks for.
 */
export class PasswordStrengthComponent extends React.Component {
    constructor(props) {
        super(props);
        this.regex = {
            strong: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(?=.{12,})/,
            medium: /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{10,}))|((?=.*[a-zA-Z])(?=.*[0-9])(?=.{12,}))/
        };
    }
    render() {
        let strength = 'weak';
        let word = 'svagt';
        switch (true) {
            case this.regex.strong.test(this.props.password):
                strength = 'strong';
                word = 'stærkt';
                break;
            case this.regex.medium.test(this.props.password):
                strength = 'medium';
                word = 'middel';
                break;
            default:
                strength = 'weak';
                word = 'svagt';
                break;
        }
        const pw = !!this.props.password ? this.props.password : '';
        const styles = {
            width: `${(100 / 12.0) * Math.min(pw.length, 12)}%`
        };
        return (React.createElement("div", { className: "bi-meter", role: "img", "aria-label": `Passwordets styrke: ${word}` },
            React.createElement("div", { className: `bi-meter-fill strength-${strength}`, style: Object.assign({}, styles) })));
    }
}
